import React from 'react';
import PropTypes from 'prop-types';
import sx from '@styled-system/css';
import styled from '@emotion/styled';
import variant from '@styled-system/variant';
import shouldForwardProp from '@styled-system/should-forward-prop';
import Base from './base';
import { DISABLED_COLOR } from './shared';

const Link = styled(Base, { shouldForwardProp })(
  ({ disabled = false }) =>
    sx({
      borderRadius: 0,
      '&[disabled]': {
        color: DISABLED_COLOR,
        '&:hover': {
          color: DISABLED_COLOR,
        },
        '&:active': {
          color: DISABLED_COLOR,
        },
      },
      ...(disabled && {
        color: DISABLED_COLOR,
        '&:hover': {
          color: DISABLED_COLOR,
        },
        '&:active': {
          color: DISABLED_COLOR,
        },
      }),
    }),
  variant({
    variants: {
      default: {
        color: 'black',
        '&:hover': {
          color: 'grays.2',
        },
        '&:active': {
          color: 'grays.1',
        },
      },
      primary: {
        color: 'indigos.3',
        '&:hover': {
          color: 'indigos.1',
        },
        '&:active': {
          color: 'indigos.1',
        },
      },
      alt: {
        color: 'grays.2',
        '&:hover': {
          color: 'grays.1',
        },
        '&:active': {
          color: 'grays.1',
        },
      },
      light: {
        color: 'grays.7',
        '&:hover': {
          color: 'grays.3',
        },
        '&:active': {
          color: 'grays.2',
        },
      },
    },
  }),
);

Link.propTypes = {
  /** content to be rendered inside of the button. Could be text or text paired
   * with an icon.
   */
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOfType([
    PropTypes.oneOf(['default', 'primary', 'alt', 'light']),
    PropTypes.arrayOf(PropTypes.oneOf(['default', 'primary', 'alt', 'light'])),
  ]),
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
    PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])),
  ]),
  /** apply this prop if the button isn't interactible */
  disabled: PropTypes.bool,
};

Link.defaultProps = {
  variant: 'default',
  size: 'md',
  disabled: false,
};

Link.displayName = 'Monterey(Button.Link)';

export default Link;
